import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const timelineOptions = [
  "ASAP",
  "1-2 weeks",
  "2-3 weeks",
  "1 month",
  "2+ months",
  "Just exploring",
];

const budgetRanges = [
  "Under $2,000",
  "$2,000 - $4,000",
  "$5,000 - $10,000",
  "$10,000 - $15,000",
  "$15,000 - $20,000",
  "$20,000+",
];

export const ProjectDetailsStep = ({ formData, onInputChange }) => (
  <div data-testid="quote-step-2" className="space-y-6">
    <div>
      <h2 className="font-heading text-2xl font-bold uppercase text-brand-navy mb-2">
        Project Details
      </h2>
      <p className="text-brand-slate">Help us understand your project better</p>
    </div>

    <div className="space-y-4">
      <div>
        <Label htmlFor="description" className="text-brand-navy">
          Project Description *
        </Label>
        <Textarea
          id="description"
          data-testid="project-description"
          placeholder="Describe your project, including scope, goals, and any specific requirements..."
          value={formData.project_description}
          onChange={(e) => onInputChange("project_description", e.target.value)}
          className="mt-2 min-h-[120px] border-border focus:border-brand-orange"
        />
      </div>

      <div>
        <Label htmlFor="property_size" className="text-brand-navy">
          Property/Project Size
        </Label>
        <Input
          id="property_size"
          data-testid="property-size"
          placeholder="e.g., 2,500 sq ft, "
          value={formData.property_size}
          onChange={(e) => onInputChange("property_size", e.target.value)}
          className="mt-2 border-border focus:border-brand-orange"
        />
      </div>

      <div>
        <Label className="text-brand-navy">Desired Timeline</Label>
        <Select
          value={formData.timeline}
          onValueChange={(value) => onInputChange("timeline", value)}
        >
          <SelectTrigger data-testid="timeline-select" className="mt-2 border-border">
            <SelectValue placeholder="Select timeline" />
          </SelectTrigger>
          <SelectContent>
            {timelineOptions.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="text-brand-navy">Budget Range</Label>
        <Select
          value={formData.budget_range}
          onValueChange={(value) => onInputChange("budget_range", value)}
        >
          <SelectTrigger data-testid="budget-select" className="mt-2 border-border">
            <SelectValue placeholder="Select budget range" />
          </SelectTrigger>
          <SelectContent>
            {budgetRanges.map((range) => (
              <SelectItem key={range} value={range}>
                {range}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);
